import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import Header from '../../HomePage/Header/Header'
import Footer from '../../HomePage/Footer/Footer'
import HourglassLoader from '../../../Common/HourglassLoader';
import ReCAPTCHA from "react-google-recaptcha";
import FeedbackForm from '../../FeedbackForm/FeedbackForm';

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const ResetPassword = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null);

    const thisemail = location.state?.email;
    const [faIcon, setfaIcon] = useState('fa-eye-slash');
    const togglePasswordType = () => {
        let input_pass = document.getElementById('password-field');
        const toggle_pass = document.getElementById("toggle_pass");
        let input_type = input_pass.getAttribute('type');
        if (input_type == "password") {
            setfaIcon('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon('fa-eye-slash')
            input_pass.type = "password"
        }
    }
    const [faIcon1, setfaIcon1] = useState('fa-eye-slash');
    const togglePasswordType1 = () => {
        let input_pass = document.getElementById('password-field_1');
        const toggle_pass = document.getElementById("toggle_pass_1");
        let input_type = input_pass.getAttribute('type');
        if (input_type == "password") {
            setfaIcon1('fa-eye');
            input_pass.type = "text";
        } else {
            setfaIcon1('fa-eye-slash')
            input_pass.type = "password"
        }
    }

    let [initialValues, setInitialValues] = useState({

        password: "",
        cpassword: "",


    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            password: Yup.string()
                .required("Password is required")
                .min(6, "Password must be at least 6 characters long"),
            cpassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required("Confirm Password is required"),


        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {
                if (!captchaToken) {
                    setCaptchaError("Please complete the CAPTCHA.");
                    return;
                }
                setSubmitting(true);
                values.email = thisemail
                await axios.post(`${host}/api/web/reset-password`, {
                    ...values,
                    captchaToken
                })
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success(response.data.message);
                            resetForm();

                            navigate('/login')

                        } else {
                            if (captchaRef.current) {
                                captchaRef.current.reset(); // Reset the CAPTCHA
                            }
                            setCaptchaToken(null);
                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {

                        if (captchaRef.current) {
                            captchaRef.current.reset(); // Reset the CAPTCHA
                        }
                        setCaptchaToken(null);
                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {
                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);

                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <div>
            <FeedbackForm />
            <Header />
            <div className="login-background">
                {/* <section class="forget-screen-main-secion main-section"> */}
                <div className="login-main-container-two login-main-container">
                    <div className="row login-form-part">
                        <div className="card login-form bg-white">
                            <h3 className="mb-0">Reset password</h3>
                            <p>Enter your new password</p>
                            <form method='post' onSubmit={formik.handleSubmit}>
                                <label htmlFor="" className="label">
                                    {" "}
                                    Enter New Password
                                </label>
                                <div className="input-group">
                                    <input
                                        placeholder="Enter Your Password"
                                        id="password-field"
                                        type="password"
                                        className="input-form"
                                        name="password"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.password}
                                        maxLength={20}
                                    />
                                    <i
                                        toggle="#password-field" className={`fa-regular ${faIcon} field-icon toggle-password `} id="toggle_pass" onClick={togglePasswordType}
                                    />

                                </div>
                                <div className="help-block with-errors">
                                    {formik.touched.password && formik.errors.password ? (
                                        <div className='text-danger'>{formik.errors.password}</div>
                                    ) : null}
                                </div>
                                <label htmlFor="" className="label">
                                    {" "}
                                    Confirm Password
                                </label>
                                <div className="input-group">
                                    <input
                                        placeholder="Confirm Password"
                                        id="password-field_1"
                                        type="password"
                                        className="input-form"
                                        name="cpassword"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.cpassword}
                                        maxLength={20}
                                    />
                                    <i
                                        toggle="#password-field_1" className={`fa-regular ${faIcon1} field-icon toggle-password `} id="toggle_pass" onClick={togglePasswordType1}
                                    />

                                </div>
                                <div className="help-block with-errors">
                                    {formik.touched.cpassword && formik.errors.cpassword ? (
                                        <div className='text-danger'>{formik.errors.cpassword}</div>
                                    ) : null}
                                </div>
                                {/* <Link>
                                    <p className="text-end remember-text">Remember your password?</p>
                                </Link> */}

                                <div className='mb-2'>
                                    <ReCAPTCHA
                                        sitekey={siteKey}
                                        onChange={handleCaptcha}
                                        ref={captchaRef} // Attach the ref to the CAPTCHA
                                    />
                                    {captchaError && <div className="text-danger">{captchaError}</div>}
                                </div>

                                <button
                                    type="submit"
                                    disabled={formik.isSubmitting}
                                    className="btn btn-primary reset-btn mb-3"
                                >
                                    {formik.isSubmitting ? <HourglassLoader /> : 'Reset Password'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
                {/* </section> */}
            </div>
            <Footer />
        </div>
    )
}

export default ResetPassword